import { toast } from "react-toastify";

import Docks from "../../../api/docks";

export const docks = {
  state: {
    docks: [],
    loading: false,
  },
  reducers: {
    setDocks(state, payload) {
      return {
        ...state,
        docks: payload,
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    clearStore() {
      return {};
    },
    setError(state, payload) {
      return {
        ...state,
        error: {
          data: payload?.data,
          message: payload?.message,
          showDialog: payload?.showDialog
        }
      }
    },
    setClearDockErrors(state, payload) {
      return {
        ...state,
        error: payload
      }
    }
  },
  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        let data = [];
        if (payload) {
          const res = await Docks.listByBranch(payload);
          data = res.data;
        }
        this.setDocks(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async addAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          docks: { docks },
        } = rootState;
        const { data } = await Docks.add(payload);
        this.setDocks([...docks, data]);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return { success: false, message: "Erro ao adicionar doca." };
      }
      return { success: true, message: "Doca adicionada com sucesso." };
    },
    async updateAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          docks: { docks },
        } = rootState;
        await Docks.update(payload).then(
          (response) => {
            this.setError(response.data);
            this.setDocks(docks.map((d) => (d.id === response.data.dockData.id ? response.data.dockData : d)));
          }
        );
        this.loading({ loading: false });
      } catch (error) {
        this.setError(error.response?.data);
        this.loading({ loading: false });
        return { success: false, message: "Erro ao atualizar doca." };
      }
      return { success: true, message: "Doca atualizada com sucesso." };
    },
    async deleteAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          docks: { docks },
        } = rootState;
        await Docks.delete(payload.id, payload.id_plant).then(
          (response) => this.setError(response.data)
        );
        this.setDocks(docks.filter((d) => d.id !== payload.id));
        this.loading({ loading: false });
      } catch (error) {
        this.setError(error.response.data);
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async clearDockErrors (payload, rootState) {
      return this.setClearDockErrors(payload, rootState);
    }
  }),
};
